import { POST } from "../APiHelper/API"

export const getPlayerStats = (player_id, onSuccess, onError) => {
    const data = {
        player_id: player_id,
    }
    POST(`/api/v1/squads/player_stats`, data, onSuccess, onError)
}